import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/utils";
import { Input, TInputProps } from "../Input";

const PasswordInput = React.forwardRef<HTMLInputElement, TInputProps>(({ className, ...props }, ref) => {
  const [show, setShow] = React.useState(false);

  return (
    <div className="relative w-full h-14">
      <Input
        {...props}
        type={show ? "text" : "password"}
        className={cn("pr-10", className)}
        ref={ref}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        onClick={() => setShow((v) => !v)}
        className="absolute top-7 right-3 text-muted-foreground hover:text-foreground focus:outline-none"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
